import React, { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Landing from 'ui/pages/landing'
import { IntlContext } from 'context/LocaleContext'
import { findMatchingLocale } from '../libs/i18n'

const Home = () => {
  const { locale, changeLocale } = useContext(IntlContext)

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.has('locale')) {
      const newLocale = findMatchingLocale(queryParams.get('locale'))
      if (newLocale && locale !== newLocale) {
        changeLocale(newLocale)
        queryParams.delete('locale')
        history.replace({
          search: queryParams.toString(),
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Landing />
}

export default Home
